import React from 'react';
import Relay from 'common/oldJavascripts/utils/react/Relay.js';
import collection from 'common/oldJavascripts/utils/collection.js';
import T from 'common/oldJavascripts/utils/i18n';
import Loader from 'common/components/Loader';
import Form from 'common/oldJavascripts/components/Shared/Form';
const Field = Form.Field;

export default Relay.createClass({
  statics: {
    mutators: {
      reviewersPool: {
        info: function(_, related) {
          var routerParams = related['/router/params'];

          return {
            id: '/projects/' + routerParams.projectId + '/reviewers',
          };
        },
      },
    },

    queries: {
      reviewers: {
        info: function(_, related) {
          var routerParams = related['/router/params'];

          return {
            id:
              '/projects/' + routerParams.projectId + '/reviewers/option-list',
          };
        },
      },
    },
  },

  render: function() {
    var self = this;
    var reviewers = self.props.reviewers;
    var reviewersPool = self.props.reviewersPool;
    var options = [];

    if (reviewers.status === 'loading') {
      return <Loader />;
    }

    reviewers = reviewers.data;

    options = collection.map(reviewers.items, function(reviewer) {
      return {
        value: reviewer.id,
        label: reviewer.first_name + ' ' + reviewer.last_name,
        // clearable: true,
      };
    });

    return (
      <Form mutator={reviewersPool} action="edit">
        <Field
          mutator={reviewersPool}
          name="reviewers_ids"
          type="autocomplete"
          options={options}
          multiple={true}
          label={T('project.documents.reviewer_pool.title')}
          onChange={this._changeReviewersIds}
          hideLabel={true}
        />
      </Form>
    );
  },

  _changeReviewersIds: function(reviewersIds) {
    const {
      routerParams: { projectId } = {},
      reviewersPool = {},
      invalidateByPatterns,
    } = this.props;
    reviewersPool.updateAndSave({ reviewers_ids: reviewersIds }, 'edit', () => {
      invalidateByPatterns([`/projects/${projectId}/reviewers/option-list`]);
    });
  },
});
